import { render } from "./RequestCertView.vue?vue&type=template&id=551c8fae"
import script from "./RequestCertView.vue?vue&type=script&lang=js"
export * from "./RequestCertView.vue?vue&type=script&lang=js"

import "./RequestCertView.vue?vue&type=style&index=0&id=551c8fae&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__